import type { ReactNode } from 'react';
import { cn } from '~/lib/utils';

const VARIANTS = {
  default: 'bg-tag text-tag-foreground',
  marine: 'bg-tag-secondary text-tag-secondary-foreground',
  opaque: 'bg-tag/85 text-tag-foreground/85',
  // Primary used when on a secondary background
  primary: 'bg-background text-tag-foreground',
};

const SIZES = {
  default: 'px-4 py-2',
  xs: 'px-3 py-1',
  sm: 'py-1.5 px-4',
  lg: 'py-4 px-8',
};

interface TagProps {
  children: ReactNode;
  variant?: keyof typeof VARIANTS;
  size?: keyof typeof SIZES;
  className?: string;
  rest?: Record<string, unknown>;
}

export function Tag({ variant = 'default', children, size = 'default', className, ...rest }: TagProps) {
  return (
    <span
      className={cn(
        'font-spaceMono text-primary inline-flex items-center rounded text-xs uppercase',
        SIZES[size],
        VARIANTS[variant],
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
